import React, { useState } from "react";
import { Page } from "../../layout/page";
import { Button, Group } from "@mantine/core";
import { useServerApi } from "../../hooks/userServerApi";
import FiscalPeriodSelect from "../../components/accounting/FiscalPeriodSelect";
import SubledgerReconciliationView from "../../components/accounting/SubledgerReconciliationView";

const SubledgerReconciliation = () => {
  const [api] = useServerApi();
  const [reports, setReports] = useState([]);
  const [fiscalPeriodId, setFiscalPeriodId] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const query = {};
      if (fiscalPeriodId) query.fiscalPeriodId = fiscalPeriodId;
      const data = await api.Accounting.getSubledgerReconciliation(query);
      setReports(data?.reports || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page title="Subledger Reconciliation">
      <Group mb="md" align="flex-end">
        <FiscalPeriodSelect value={fiscalPeriodId} onChange={setFiscalPeriodId} />
        <Button onClick={load} loading={loading}>
          Refresh
        </Button>
      </Group>
      <SubledgerReconciliationView reports={reports} />
    </Page>
  );
};

export default SubledgerReconciliation;
